import { useTranslation } from 'react-i18next'

import { Divider } from '../../../../../Divider'
import Text from '../../../../../Text'

import * as styles from './ListingProfileHeaderStatusSelectNote.module.css'

function ListingProfileHeaderStatusSelectNote({
  className = styles.ListingProfileHeaderStatusSelectNote,
}) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <Divider />
      <Text isSecondary className={styles.text}>
        {t('RentalPortal.ListingStatusSelectPortalNoteKey')}
      </Text>
    </div>
  )
}

export default ListingProfileHeaderStatusSelectNote
